export default {
  // Auth methods
  async login(username, password) {
    const result = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
      credentials: 'include'
    });

    if (!result.ok) {
      const error = await result.json();
      throw new Error(error.error || 'Kirjautuminen epäonnistui');
    }

    return result.json();
  },

  async logout() {
    const result = await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include'
    });
    return result.json();
  },

  async verify() {
    const result = await fetch('/api/auth/verify', {
      credentials: 'include'
    });
    return result.json();
  },

  // Existing methods with credentials added
  async getPresets() {
    const result = await fetch('/api/preset', { credentials: 'include' });
    const data = await result.json();
    return data;
  },
  async goToPreset(preset_index) {
    const result = await fetch(`/api/preset/${preset_index}`, {
      method: 'POST',
      credentials: 'include'
    });
    const data = await result.text();
    console.log(data);
  },
  async data() {
    const result = await fetch('/api/data', { credentials: 'include' })
    const data = await result.json();
    return data;
  },
  async saaData() {
    const result = await fetch('/api/saa', { credentials: 'include' })
    const data = await result.json();
    return data;
  },
  async shellyData() {
    // log stack trace for debugging
    console.trace('Fetching Shelly data', new Error().stack);

    const result = await fetch('/api/shelly', { credentials: 'include' })
    const data = await result.json();
    return data;
  },
  async setShellyPlug(to) {
    const result = await fetch('/api/shelly/plug', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        state: to
      })
    })
    const data = await result.json();
    return data;
  }
}
